<app-entity-transaction-modal
  modalTitle="TRANSACTIONS"
  ariaLabelledBy="entity-loan-details-modal-title"
  [dataLoading]="dataLoading()"
  [dataAvailable]="dataAvailable()"
  [dataEmpty]="dataEmpty()"
  [columns]="columns()"
  [currentPage]="currentPage()"
  [sortField]="sortField()"
  [sortOrder]="sortOrder()"
  (sortChanged)="sort($event)"
  (searchChanged)="search($event)"
  (pageChanged)="page($event)">
  <ng-container entityInfo>
    <h2>Name: {{entityLoan().name}}</h2>
    <h2>Type:
      @if (entityLoan().loanType) {
        <span>{{entityLoan().loanType}}</span>
      }
      @if (!entityLoan().loanType) {
        <span class="fallback-text">(Empty)</span>
      }
    </h2>
    <h2>Balance: {{entityLoan().balance.displayValue}}</h2>
  </ng-container>
</app-entity-transaction-modal>
